import { DataType } from '../../../../../../../models/Enums';
import ValidationRuleModel, { IValidationRuleProvider } from '../../../../../../../models/ValidationRuleModel';

const ValidationRules: IValidationRuleProvider = {
    "challengesOfUsingMalariaSurveillanceData": new ValidationRuleModel(DataType.String, true)
};

export default ValidationRules;